import React, { useState } from "react";

import { APP_COLORS, ChecklistPopover } from "components/ModelProgressBar";
import ProgressCircle from "assets/images/icons/JSX/progressCircle";

import checklistClasses from "components/ModelProgressBar/style.module.scss";
import classes from "./styles.module.scss";

const ReviewProgressIndicator = ({ percentage, checks, modelComplete = false, hasSimulationResults = false }) => {
    const [hovered, setHovered] = useState(false);
    const hasAttentionItems = checks.length > 0;
    const showPopover = hovered && (modelComplete || hasAttentionItems);
    const completeMessage = hasSimulationResults ? "Model complete" : "Model ready for simulation";

    return (
        <span
            className={classes.reviewProgressIndicator}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <ProgressCircle
                percentage={percentage}
                color={APP_COLORS.green}
                complete={modelComplete}
            />
            {showPopover && (
                <div
                    className={classes.reviewProgressPopover}
                    style={modelComplete ? { marginTop: 0 } : undefined}
                >
                    {modelComplete ? (
                        <div className={checklistClasses.checklistPopover}>
                            <div className={checklistClasses.checklistItem}>
                                <span className={checklistClasses.checklistItemPending}>{completeMessage}</span>
                            </div>
                        </div>
                    ) : (
                        <ChecklistPopover
                            items={checks}
                            label="Review"
                            title={`${Math.round(percentage)}% completed`}
                        />
                    )}
                </div>
            )}
        </span>
    );
};

export default ReviewProgressIndicator;
